import {
  IconAudio,
  IconChainLink1,
  IconLock,
  IconMicrophone,
  IconShield,
  IconSuitcaseWork,
  IconUser,
  IconVideo,
} from "central-icons-outline";
import type { ComponentType } from "react";

import type { ContractTemplateIconId } from "@/types/contractIntelligence.types";

type CentralIconComponent = ComponentType<{
  size?: number;
  className?: string;
  ariaHidden?: boolean;
}>;

const ICONS: Record<ContractTemplateIconId, CentralIconComponent> = {
  shield: IconShield,
  music: IconAudio,
  link: IconChainLink1,
  briefcase: IconSuitcaseWork,
  lock: IconLock,
  mic: IconMicrophone,
  video: IconVideo,
  user: IconUser,
};

interface TemplateIconProps {
  name: ContractTemplateIconId;
  className?: string;
}

export function TemplateIcon({ name, className }: TemplateIconProps) {
  const Icon = ICONS[name] ?? IconSuitcaseWork;
  return <Icon className={className} size={16} ariaHidden />;
}
